<template>
  <span class="assignment-lock">
    <fieldset :disabled="disabled || pending || !hasAssignment">
      <AppSwitcher
        :key="`${assignment[field]}-${pending}`"
        :value="assignment[field]"
        :readonly="disabled || pending || !hasAssignment"
        @change="change"
      />
    </fieldset>
    <small v-if="pending" role="status">Unlocking…</small>
    <small v-else-if="assignment[field] && !assignment[`_initial_${field}`]">Locks on save</small>
    <small v-if="error" class="assignment-lock__error" role="alert">{{ error }}</small>
  </span>
</template>

<script>
import AppSwitcher from '@/components/AppSwitcher'
import { postReservationSafariAssignmentUnlock } from '@/http'
import { changeSafariAssignmentLock } from '@/utils/safari-assignment-locks'

export default {
  name: 'SafariAssignmentLock',
  components: { AppSwitcher },
  props: {
    assignment: { type: Object, required: true },
    safariId: { type: [Number, String], required: true },
    field: { type: String, required: true, validator: value => ['car_assignment_locked', 'guide_assignment_locked'].includes(value) },
    disabled: { type: Boolean, default: false },
  },
  data() { return { pending: false, error: '' } },
  computed: {
    hasAssignment() { return Boolean(this.field === 'car_assignment_locked' ? this.assignment.car : this.assignment.driver) },
  },
  methods: {
    async change(value) {
      if (this.pending || this.disabled || !this.hasAssignment) return
      this.error = ''
      this.pending = true
      this.$emit('busy', true)
      try {
        await changeSafariAssignmentLock(postReservationSafariAssignmentUnlock, this.safariId, this.assignment, this.field, value)
      } catch (error) {
        this.error = (error.response && error.response.data && error.response.data.details) || 'Unable to unlock. Please try again.'
      } finally {
        this.pending = false
        this.$emit('busy', false)
      }
    },
  },
}
</script>

<style scoped>
.assignment-lock { display: inline-flex; flex-direction: column; gap: 4px; }
.assignment-lock fieldset { border: 0; padding: 0; margin: 0; }
.assignment-lock small { max-width: 220px; }
.assignment-lock__error { color: #b42318; }
.assignment-lock ::v-deep .switcher--active .switcher__body { background-color: #e5ad18; }
</style>
